
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConspicuousCairn as ObiConspicuousCairnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-conspicuous-cairn.js';
 
 
 

 
 export const ObiConspicuousCairn = createComponent({
   react: React,
   tagName: 'obi-conspicuous-cairn',
   elementClass: ObiConspicuousCairnElement,
   events: {
     
   }
  });
 
 